import React from 'react';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@adscore/with-responsive-size';
import { Skeleton, SkeletonItem } from '@fluentui/react-components';

import { AdAssetsPreviewerShimmer } from './ad-assets-step-shimmer';
import { PreviewFormShimmer } from './preview-form-shimmer';
import { getPreviewAssetsStepShimmerStyles } from './styles/preview-assets-step-shimmer-styles';

export const PreviewAssetsStepShimmer = () => {
  const classes = useDefaultStyles(getPreviewAssetsStepShimmerStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);

  return (
    <div className="preview-assets-step-shimmer">
      <div className={classes.stepTitle}>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '35px', width: '100%' }} /> </Skeleton>
      </div>
      <div className={classes.stepDescription}>
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '20px', width: '100%' }} /> </Skeleton>
      </div>
      <div className={classNames('preview-assets-step-content', classes.previewStepContent, classes[`previewStepContent-${displayMode}`])}>
        <div className={classNames('preview-assets-group', classes.previewGroup, classes[`previewGroup-${displayMode}`])}>
          <PreviewFormShimmer />
          <PreviewFormShimmer />
          <PreviewFormShimmer />
        </div>
        <div className={classNames('ad-preview-container', classes.adPreviewContainer, classes[`adPreviewContainer-${displayMode}`])}>
          <AdAssetsPreviewerShimmer />
        </div>
      </div>
    </div>
  );
};
